import { ReactNode, useMemo } from 'react';
import { PersonTypes } from '@frontend/api-person';
import { contextFactory } from '@frontend/design-system';

export type PersonInfoStore = {
  personInfo: PersonTypes.Person;
};

export const [PersonInfoContext, usePersonInfoContext] = contextFactory<PersonInfoStore>(
  'usePersonInfoContext must be used within a PersonInfoStoreProvider'
);

export const PersonInfoStoreProvider = ({
  children,
  personInfo,
}: {
  children: ReactNode;
  personInfo: PersonTypes.Person;
}) => {
  const value = useMemo(() => ({ personInfo }), [personInfo]);
  return <PersonInfoContext.Provider value={value}>{children}</PersonInfoContext.Provider>;
};
